module.exports = __webpack_public_path__ + "static/img/cycle.373fd2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cycle.png
// module id = 130
// module chunks = 1